
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Sursă de date',
	'dataSourceId': 'ID',
	'dataSourceType': 'Tip',
	'dataSourceName': 'Nume',
	'dataSourcePath': 'Cale',
	'showInfoForAll': 'Afişare durată pentru toate vizualizările',
	'hideInfoForAll': 'Ascundere durată pentru toate vizualizările',
	'showPerformanceDetails': 'Rulaţi din nou toate widget-urile pentru a include detalii',
	'slotMappingField': 'Mapări slot',
	'slotDataMapping': 'Mapare',
	'slotID': 'ID',
	'slotCaption': 'Subtitlu',
	'slotMandatory': 'Obligatoriu',
	'slotIsMandatory': 'Da',
	'slotIsNotMandatory': 'Nu',
	'infoNotAvailable': 'Indisponibil',
	'performanceSection': 'Performanţă',
	'durationField': 'Durată',
	'singleQueryTime': 'Interogare server (ms)',
	'multipleQueryTime': 'Interogare server %{name} (ms)',
	'liveWidgetTotalTime': 'Total (ms)',
	'renderTimeNotAvailable': 'Indisponibil',
	'renderInProgress': '(în curs)',
	'interactToTriggerQuery': 'Interacţionaţi cu widget-ul pentru a declanşa o interogare',
	'fetchQuery': 'Aducere interogare',
	'showSQLMDX': 'Afişare SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informaţii de interogare',
	'queryInfoNotAvailable': 'Informaţii de interogare indisponibile',
	'query': 'Întrebare',
	'copy': 'Copiere',
	'close': 'Închidere'
});
